const en_master_goods = {
	access_chasier: "cashier access",
	access_request: "request access",
	add: "add item",
	barcode: "barcode",
	edit: "edit item",
	name: "item name",
	price: "item price",
	upload: "upload item",
	view: "item detail",

	form: {
		courier: "instant courier",
		low_stock: "minimum stock alert",
		name: "item name",
		min_order: "minimum order",
		po: "pre-order item",
		po_time: "pre-order duration",
		ppn_label: "* price includes PPN",
		stock: "non-stock / stock",
		is_ppn: "non PPN / PPN",
	},

	message: {
		note_upload: "Note: only Excel format files can be uploaded.",
		note_excel: "Download sample Excel file",
		note_term_title: "File requirements:",
		note_term_1: "Use the sample file.",
		note_term_2: "Columns NamaBarang, Tipe, TipeStok, Keterangan, Lokasi, HargaBeli, HargaJual, and StokMinimum are required.",
		note_term_3: "Items already in the database will not be re-imported.",
		note_term_4: "Barcode column is optional. The system will generate it if empty.",
		note_term_5: "Lokasi column represents the storage location of the item.",
		note_term_6: "Berat column must be filled in grams.",
		note_term_7: "Satuan column is used as the standard quantity unit in transactions.",
		note_term_8: "StokMinimum column is used to trigger alerts when stock is low.",
		note_term_9: "Item type must be filled with:",
		note_term_9_1: 'Number "1" for items without serial numbers.',
		note_term_9_2: 'Number "2" for items with serial numbers. Serial numbers are entered when goods are received in the warehouse.',
		note_term_9_3: 'Number "3" for items with serial numbers. Serial numbers are entered before goods are issued from the warehouse.',
		note_term_10: "TipeStok column must be filled with 1 (has stock) or 0 (no stock / service).",
		note_term_11: "Merek, Warna, and Ukuran columns are optional.",
	},

	error: {
		category: "Item category cannot be empty.",
		create: "Failed to create item.",
		delete: "Failed to delete item.",
		edit: "Failed to update item.",
		name: "Item name cannot be empty.",
		po_duration: "Pre-order duration must be greater than 0.",
		unit: "Item unit cannot be empty.",
		type: "Item type cannot be empty.",
		whs1: "Item warehouse cannot be empty.",
		whs2: "At least 1 warehouse is required.",
	},

	success: {
		create: "Item created successfully.",
		delete: "Item deleted successfully.",
		edit: "Item updated successfully.",
	}
}

export default en_master_goods